/**
 * Get whether a resource is a Collection.
 * @returns boolean
 */
export const getResourceIsCollection = (): boolean => {
  if (BFG.resource.type === 'collection') return true;
  return false;
};

/**
 * Get whether a resource is a Share Link (aka Share Manifest).
 * @returns boolean
 */
export const getResourceIsShareLink = (): boolean => {
  if (BFG.manifestDigest || BFG.manifest?.key) return true;
  return false;
};

/**
 * Get whether a resource is a Collection or Share Link.
 * @returns boolean
 */
export const getResourceIsCollectionOrShareLink = (): boolean => getResourceIsShareLink() || getResourceIsCollection();
